// extracted by mini-css-extract-plugin
module.exports = {"main":"GPmiXv","headercontainer":"b0ZG6i","header":"mjZ8t9","description":"X8Uza9"};